import React from 'react';
/*Itemをインポート*/
import Item from '../Item/Item';

const List = (props) => {
  /*変数Itemsを定義する。mapメソッドでvideosの中にあるデータを一つずつ取り出し、Item componentにpropsとして渡す。この時点で動画の数x<Item video = {video}の配列が完成。つまり、ItemsはJSXを含む配列*/
  const Items = props.videos.map((video) => {

    if(props.selectedVideo !== video) {
      return (
      <Item video={video}
              key={video.id.videoId}
              onVideoClicked={props.onVideoClicked}
         />
     );
    }
   return false;
  });

  return (
    <ul className="col-md-4 list-group">
        {/*JSX内に変数Itemsを挿入*/}
        { Items }
    </ul>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/components/Video/List/List.js